import type { InfiniteData } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { queryClient } from '@core/Data/ReactQuery/queryClient'
import { followMePrincipleProfileQuery } from '@core/Areas/FollowMe/helpers/queries'
import type { FollowMeSharedBet, FollowMeProfile } from '@core/Areas/FollowMe/types'

export function patchFeedDataWithIsFollowingChange({
  profileId,
  isFollowing,
}: {
  profileId: string
  isFollowing: boolean
}) {
  patchFeeds(old =>
    old
      ? {
          ...old,
          pages: old.pages.map(page =>
            page.map(bet => {
              let ownerAccountFollowerCount = bet.ownerAccountFollowerCount
              return bet.ownerAccountId === profileId
                ? {
                    ...bet,
                    isFollowing,
                    isNotificationsEnabled: false,
                    ownerAccountFollowerCount: isFollowing
                      ? ++ownerAccountFollowerCount
                      : --ownerAccountFollowerCount,
                  }
                : bet
            })
          ),
        }
      : old
  )
}

export function patchFeedDataWithNotificationChange({
  accountId,
  isNotificationsEnabled,
}: {
  accountId: string
  isNotificationsEnabled: boolean
}) {
  patchFeeds(old =>
    old
      ? {
          ...old,
          pages: old.pages.map(page =>
            page.map(bet =>
              bet.ownerAccountId === accountId ? { ...bet, isNotificationsEnabled } : bet
            )
          ),
        }
      : old
  )
}

export function patchPrincipalDataWithFollowingCount(isNowFollowing: boolean) {
  const delta = isNowFollowing ? 1 : -1
  queryClient.setQueryData<FollowMeProfile>(followMePrincipleProfileQuery.queryKey, old =>
    old ? { ...old, followingCount: Math.max(0, old.followingCount + delta) } : old
  )
}

// =============
// Local Helpers
// =============

function patchFeeds(
  updater: (
    old?: InfiniteData<FollowMeSharedBet[]>
  ) => InfiniteData<FollowMeSharedBet[]> | undefined
) {
  queryClient.setQueriesData<InfiniteData<FollowMeSharedBet[]>>(
    { queryKey: queryKeys.followMeSharedBetsFeedBase() },
    updater
  )
}
